import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Store from './store'
import Editor from './Editor'
import Viewer from './Viewer'
import isEqual from 'lodash/isEqual'

@inject('certificationStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.certificationStore)
  }

  componentDidMount() {
    const { item } = this.props
    this.store.init(item)
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.item, this.props.item)) {
      const { item } = this.props
      this.store.init(item)
    }
  }
  render() {
    const { type } = this.store

    switch (type) {
      case 'editor':
        return <Editor store={this.store} />
      case 'viewer':
        return <Viewer store={this.store} />
      default:
        return null
    }
  }
}
